import { render, staticRenderFns } from "./AdminClientClosure.vue?vue&type=template&id=18c25f08&"
import script from "./AdminClientClosure.vue?vue&type=script&lang=js&"
export * from "./AdminClientClosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports